import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MemberSubmission } from '../../../../models/submissions/member-submission';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-pending-submission-modal-card',
  templateUrl: './pending-submission-modal-card.component.html',
  styleUrls: ['./pending-submission-modal-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingSubmissionModalCardComponent implements OnChanges {
  @Input() submission: MemberSubmission | null = null;

  private _submission = new BehaviorSubject<MemberSubmission | null>(null);
  public submission$ = this._submission.exists();

  public submissionName$ = this.submission$.pipe(map(sub => sub?.submissionTypeName));
  public submissionOwner$ = this.submission$.pipe(map(sub => sub?.owner?.fullName));

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.submission) {
      this._submission.next(this.submission);
    }
  }
}
